<template>
  <span>
    <span>
      User Name: <br />
      <slot :user="user">{{ user.Name }}</slot></span
    >
    <br />
    <span><slot name="position" :position="user.JobTitle"></slot></span>
  </span>
</template>

<script>
export default {
  name: "basicbtn",
  mixins: [],
  created() {},
  data: () => ({
    user: {
      Name: "James Bond",
      JobTitle: "unemployed",
    },
  }),
  components: {},
  props: {},
  watch: {},
  computed: {},
  methods: {},
};
</script>

<style></style>
